<template>
  <div>
        <img v-if="loading" src="../../assets/img/loader.svg" alt="loader" class="sa-loader" />
        <div class="sa-appoint-list">
      <span
        ><input type="radio" @change="getGraph" v-model="pType" id="video1" name="reports" value="all" checked/><label
          for="video1" 
          >All</label
        ></span
      >
      <span
        ><input type="radio" @change="getGraph" v-model="pType" id="video2" name="reports" value="cash" /><label
          for="video2"
          >Cash</label
        ></span
      >
      <span
        ><input type="radio" @change="getGraph" v-model="pType" id="video3" name="reports" value="insurance" /><label
          for="video3"
          >Insurance</label
        ></span
      >
    </div>
    <div class="sa-row">
      <div v-if="productData && productData.Total" class="sa-col-xs6 sa-col-sm7 sa-col-md10 sa-col-lg9">
        <span>Total Revenue </span>
        <h4 class="sa-mt10">SAR {{productData.Total.Revenue}}</h4>
        <span> Total Appointments<strong> {{productData.Total.count}}</strong></span>
      </div>
      <div class="sa-col-xs12 sa-col-sm5 sa-col-md2 sa-col-lg3">
        <div class="sa-form-group ">
          <!-- <i class="icon-down-arrow sa-form-icon sa-picker-icon"></i> -->
          <month-picker-input v-if="duration_month" :min-date="minDate" :default-month="duration_month" :default-year="duration_year" @input="showDate"></month-picker-input>
        </div>
      </div>
    </div>
    <apexchart
      v-if="sflag"
      type="line"
      height="200"
      class="line-graph"
      :options="chartOptions"
      :series="series"
    ></apexchart>
    <appointment-details :productData="productData" />
  </div>
</template>
<script>
import { MonthPickerInput } from "vue-month-picker"
import VueApexCharts from "vue-apexcharts";
import { oh_url } from "../../../config/endpoints"
import AppointmentDetails from "./AppointmentDetails.vue";

export default {
  components: {
    apexchart: VueApexCharts,
    MonthPickerInput,
    AppointmentDetails
  },

  data() {
    return {
      loading: false,
      minDate: null,
      productData: {},
      duration_month: null,
      duration_year: null,
      sflag: false,
      t_inc: null,
      t_apts: null,
      pType: 'all',
      series: [
        {
          name: "SAR",
          data: []
        },
      ],
      chartOptions: {
        // legend: {
        //   formatter: {}
        // },
        chart: {
          width: "100%",
          parentHeightOffset: 0,
          type: "line",
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 1,
          curve: "smooth",
          lineCap: "butt",
          dashArray: 0,
        },
        grid: {
          show: true,
          strokeDashArray: 3,
          xaxis: {
            lines: {
              show: false,
            },
          },
          yaxis: {
            show: true,

            lines: {
              show: true,
            },
          },
        },
        tooltip: {
          enabled: true,
          x: {
            show: false,
          },
          y: {
            formatter: {}
            // formatter: function(
            //   value,
            //   { series, seriesIndex, dataPointIndex, w }
            // ) {
            //   return value;
            // }
          },
          marker: {
            show: false,
          },
        },
        xaxis: {
          type: "category",
          categories: [],
          axisBorder: {
            show: false,
            color: "#ECF1FB",
          },
          axisTicks: {
            show: false,
          },
          crosshairs: {
            show: false,
          },
          tooltip: {
            enabled: false,
          },
        },
        yaxis: {
          // max: 0,
          show: true,
          axisBorder: {
            show: false,
            color: "#ECF1FB",
          },

          labels: {
            formatter: function (value) {
              return parseInt(value);
            },
          },
        },
      },
    };
  },
  mounted() {
    let mdate = new Date()
    this.minDate = new Date('2021-12-01')
    this.duration_month = mdate.getMonth()+1
    this.duration_year = mdate.getFullYear()
    this.getGraph()
  },
  methods: {
    showDate (date) {
      this.duration_month = date.monthIndex
      this.duration_year = date.year
      this.getGraph()
    },
    getGraph() {
      let _self = this
      _self.sflag = false
      _self.loading = true
       _self.$store
        .dispatch("httpPost", {
          uri: `${oh_url}/pro2/revdashboard`,
          body: {
            duration_month: _self.duration_month,
            duration_year:_self.duration_year,
            payment_type:_self.pType
          }
        })
        .then((response) => {
          if(response && response.status == 1000){
            _self.sflag = true
            _self.loading = false
            _self.productData = response.productData
            let chartOption = JSON.parse(JSON.stringify(_self.chartOptions))
            chartOption.xaxis.categories = response.graph_data.x
            _self.chartOptions = JSON.parse(JSON.stringify(chartOption))
            _self.series[0].data = response.graph_data.y
            _self.chartOptions.tooltip.y.formatter = function(seriesName, opts) {
              return response.graph_data.tooltip[opts.dataPointIndex]
            }
          }
        })
    }
  }
};
</script>
<style scoped>

</style>
  
